import isArray from 'lodash/isArray';
/**
 * @desc  SubstitutionService class.
 * @ngInject
 */
export default class SubstitutionService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   * @param {moment} moment
   */
  constructor(
    $rootScope, $q, $log, $http, moment
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.moment = moment;

    this.state = {
      data: {},
      fetched: false,
      lastUpdate: null
    };

    this.$rootScope.$on('scr.select', () => {
      this.state = {
        data: {},
        fetched: false,
        lastUpdate: null
      };
    });
  }

  getState() {
    return this.state;
  }

  setState(newState) {
    const state = Object.assign(this.state, newState);
    return state;
  }

  getAll(params, fromServer = false) {
    if (!this.$rootScope.me.schoolConfiguration.hasAccessToSubstitutions) {
      return this.$q.resolve([]);
    }

    if (this.state.fetched && !fromServer) {
      return this.$q.resolve(this.getState().data);
    }

    return this.$http({
      method: 'GET',
      url: '/SCR/substitutions',
      params
    }).then(result => {
      const newState = {
        data: isArray(result.data) ? result.data : result.data.data,
        fetched: true,
        lastUpdate: Date.now()
      };
      this.setState(newState);
      return this.$q.resolve(this.getState().data);
    }, err => this.$q.reject(err));
  }

  getActivity(activityId) {
    return this.$http({
      method: 'GET',
      url: `/SCR/substitutions/substituteActivities/${activityId}`
    }).then(result => result.data, err => this.$q.reject(err));
  }

  getUserActivities(userId, employeeId, date = null) {
    const activities = [];

    return this.getAll({
      schoolCommonRoomIds: [this.$rootScope.me.schoolCommonRoomId],
      substituteTeacherIds: [userId],
      dateFrom: date || null,
      dateTo: date || null
    }, true).then(result => {
      result.forEach(item => {
        if (item.substitution) {
          item.substitution.activities.forEach(activity => {
            if (String(activity.employeeId) === String(employeeId)) {
              activity.employeeName = item.employeeName;
              activity.date = item.date;
              activity.substitutionId = item.substitution.id;
              activity.workDayId = item.workDayId;
              activities.push(activity);
            }
          });
        }
      });
      return activities;
    });
  }
}
